import React from "react";

import AppLogoStepOne from "img/how-to-img/app-logo.png";
import PackageStepTwo from "img/how-to-img/product-package.png";
import ProductStepThree from "img/how-to-img/product-plus.png";
import PayStepFive from "img/how-to-img/pay.png";

export default function HowToTraveller() {
  return (
    <div className="step-list">
            <h1 className="small-heading">Steps to Duplicate a Delivery</h1>

      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={AppLogoStepOne}
            alt="Step One"
            style={{ width: "320px" }}
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 1: Open the Tripple Air App
          </h1>
          <p className="small-para">
            Launch the Tripple Air mobile app on your device. Make sure you're
            logged in with your registered account to access your delivery
            dashboard.
          </p>
        </div>
      </div>
      <div className="step-item icon-right">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={PackageStepTwo}
            alt="Step Two"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 2: Go to 'My Deliveries'
          </h1>
          <p className="small-para">
            Tap on the "My Deliveries" section from the home screen or bottom
            menu to view your delivery history.
          </p>
        </div>
      </div>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={ProductStepThree}
            alt="Step Three"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 3: Tap the Dropdown on the Delivery You Want to Duplicate
          </h1>
          <p className="small-para">
            Find the order you wish to repeat. Tap the dropdown icon (usually
            three dots or an arrow) next to that delivery to reveal more
            options.
          </p>
        </div>
      </div>
      <div className="step-item icon-right">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={PackageStepTwo}
            alt="Step Four"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 4: Select 'Duplicate'
          </h1>
          <p className="small-para">
            Tap on "Duplicate." You'll now have two options: - Repeat the exact
            same delivery - Edit delivery details (e.g., new address, package
            size, date/time) before proceeding
          </p>
        </div>
      </div>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={PayStepFive}
            alt="Step Five"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 5: Review & Pay
          </h1>
          <p className="small-para">
            Once the delivery details are set, tap "Continue," review the
            summary, and make payment to confirm the duplicate delivery.
          </p>
        </div>
      </div>
    </div>
  );
}
